import _ from "lodash";

require('../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../ComponentSet";

import utils from "../../Utils";
import Constants from "../../Constants";
import Swiper, {Autoplay, EffectFade, Navigation} from "swiper";

import 'swiper/css';
import 'swiper/css/effect-fade';

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: ComponentSet,
    mixins: [utils],
    data: { 
        
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {
    },
    mounted() {
        let self = this;
        // 取回該頁面需要用到的資料
        this.retrieveSiteContentData(function () {
            self.$nextTick(function() {
                // banner initialize
                // banner
                const banner_swiper = new Swiper(".banner_swiper", {
                    // configure Swiper to use modules
                    modules: [Navigation, Autoplay, EffectFade],
                    // Optional parameters
                    loop: true,
                    effect: 'fade',
                    autoplay:true,
                    // Navigation arrows
                    navigation: {
                        nextEl: ".banner-button-next",
                        prevEl: ".banner-button-prev",
                    },
                    on: {
                        slideChange:function(swiper){
                            $('.banner_swiper h3').hide();
                            $('.banner_swiper h3').eq(swiper.realIndex).show()
                        }
                    }
                });
            });
        });
    },
    methods: {
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        },
        bannersData() {
            return _.get(this, 'contentData.bannerList', []) || [];
        },
        data() {
            return _.get(this, 'contentData.form', []) || [];
        }
    }, // end of computed
}).$mount('#app');